/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import { SafeArea } from '../../components/utility/safe-area.components';
import React, { useContext, useState, useEffect } from 'react';
import { Spacer } from '../../components/style/spacer.component';
import { Text, ScrollView, Pressable, Modal, View } from 'react-native';
import { vaccineComputation } from '../../services/vaccine.service';
import { LocationContext } from '../../context/results.context';
 import { Ionicons } from '@expo/vector-icons';
import { styles } from '../../components/style/modal.stylesheet';
import { CardContainer } from '../../components/style/result-card.component';
import {
  MiniCardContainer,
  MiniResultCard,
  MiniResultCard2,
  MiniResultCard3,
  WhiteResultCard,
  SmallWhiteResultCard,
  Number,
  SmallNumber,
  Label,
  VaccineNumber,
  VaccineLabel,
  AssessmentText,
  VaccineResultsContainer,
  WhiteNumber,
} from '../../components/style/mini-card.component';
import { GraphContext } from '../../context/graph.context';

import { GraphComponent } from '../../components/graph.component';

export const ResultsScreen = ({ route }) => {

  // eslint-disable-next-line react/prop-types
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible2, setModalVisible2] = useState(false);

  const { age, sex, area, country } = route.params;
  // const { location, setLocation } = useState();
  const { location, retrieveCountry, countryInfo, retrieveLocation } = useContext(LocationContext);
  const {
    graphInfo,
    infectionPerPopInfo,
    graphInfoDeaths,
    graphInfoRecovered,
    vaccineInfo,
    retrieveGraphInfo,
    retrieveStateGraphInfo,
    retrieveVaccineInfo,
    retrieveGraphPerCapInfo,
  } = useContext(GraphContext);
  const results = vaccineComputation(age, sex, area);

  useEffect(() => {
    retrieveCountry();
    retrieveGraphInfo();
    retrieveVaccineInfo();
    retrieveLocation();
    if (countryInfo.country == 'USA') {
      retrieveStateGraphInfo();
    }
  }, []);

  return (
    <CardContainer>
      <ScrollView>
        <Spacer position="top" size="large">
          <AssessmentText>
            Vaccine Assessment{' '} <Pressable  onPress={() => setModalVisible(true)}> <Ionicons name="information-circle-outline" size={24} color="black" />{' '}</Pressable> 
 


<Modal
        animationType="slide"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
           setModalVisible(!modalVisible);
        }}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <Text style={styles.modalText}>Cards show the increased odds of acquiring side effects associated with each vaccine as per your age and sex profile. An odds ratio of 1 indicates that the side effect under study is equally likely to occur in the presence or absence of the vaccine. If higher than 1, it indicates that the condition is more likely to occur in the presence of the vaccine. </Text>
            <Pressable
              style={[styles.button, styles.buttonClose]}
              onPress={() => setModalVisible(!modalVisible)}
            >
              <Text style={styles.textStyle}>Hide</Text>
            </Pressable>
          </View>
        </View>
      </Modal>
          </AssessmentText>
        </Spacer>
        {results.map((item) => (
          <MiniCardContainer key={item.id}>
            {item.color == 1 && (
              <MiniResultCard3>
                <VaccineNumber>{item.vaccine} </VaccineNumber>
                <VaccineLabel>Vaccine </VaccineLabel>
                {item.case.map((each) => (
                  <VaccineResultsContainer key={each.id}>
                    {each.risk ? (
                      <WhiteNumber>{each.risk} </WhiteNumber>
                    ) : (
                      <WhiteNumber>No increased risk </WhiteNumber>
                    )}
                    <VaccineLabel>{each.se} </VaccineLabel>
                  </VaccineResultsContainer>
                ))}
              </MiniResultCard3>
            )}
            {item.color == 2 && (
              <MiniResultCard2>
                <VaccineNumber>{item.vaccine} </VaccineNumber>
                <VaccineLabel>Vaccine </VaccineLabel>
                {item.case.map((each) => (
                  <VaccineResultsContainer key={each.id}>
                    {each.risk ? (
                      <WhiteNumber>{each.risk} </WhiteNumber>
                    ) : (
                      <WhiteNumber>No increased risk </WhiteNumber>
                    )}
                    <VaccineLabel>{each.se} </VaccineLabel>
                  </VaccineResultsContainer>
                ))}
              </MiniResultCard2>
            )}

            {item.color == 3 && (
              <MiniResultCard>
                <VaccineNumber>{item.vaccine} </VaccineNumber>
                <VaccineLabel>Vaccine </VaccineLabel>
                {item.case.map((each) => (
                  <VaccineResultsContainer key={each.id}>
                    {each.risk ? (
                      <WhiteNumber>{each.risk} </WhiteNumber>
                    ) : (
                      <WhiteNumber>No increased risk </WhiteNumber>
                    )}
                    <VaccineLabel>{each.se} </VaccineLabel>
                  </VaccineResultsContainer>
                ))}
              </MiniResultCard>
            )}
          </MiniCardContainer>
        ))}

        <Spacer position="top" size="large">
          <AssessmentText>
            Location Assessment{' '} <Pressable  onPress={() => setModalVisible2(true)}> <Ionicons name="information-circle-outline" size={24} color="black" />{' '}</Pressable> 
            {/* <Tip title="Cards show the current number of cases (both current and total overall) in your current area. Graphs show the cummulative number of COVID-a9 cases and related deaths in the last 60 days as well as vaccinations.">
              <Text
                style={{
                  padding: 0,
                  fontWeight: 'bold',
                  fontSize: 15,
                }}>
                <Ionicons name="information-circle-outline" size={24} color="black" />{' '}
              </Text>
            </Tip> */}



<Modal
        animationType="slide"
        transparent={true}
        visible={modalVisible2}
        onRequestClose={() => {
           setModalVisible(!modalVisible2);
        }}
      >
        <View style={styles.centeredView}>
          <View style={styles.modalView}>
            <Text style={styles.modalText}>Cards show the current number of cases (both current and total overall) in your current area. Graphs show the cummulative number of COVID-19 cases and related deaths in the last 60 days as well as vaccinations. </Text>
            <Pressable
              style={[styles.button, styles.buttonClose]}
              onPress={() => setModalVisible2(!modalVisible2)}
            >
              <Text style={styles.textStyle}>Hide</Text>
            </Pressable>
          </View>
        </View>
      </Modal>
          </AssessmentText>
        </Spacer>
        <MiniCardContainer>
          {countryInfo.country == 'USA' && (
            <>
              <SmallWhiteResultCard>
                <SmallNumber>{location.cases} </SmallNumber>
                <Label>Total Cases in {area} </Label>
              </SmallWhiteResultCard>
              <SmallWhiteResultCard>
                <SmallNumber>{countryInfo.active} </SmallNumber>
                <Label>Total Active Cases </Label>
              </SmallWhiteResultCard>

              <SmallWhiteResultCard>
                <SmallNumber>{countryInfo.cases} </SmallNumber>
                <Label>Total Recorded Cases </Label>
              </SmallWhiteResultCard>
            </>
          )}

          {countryInfo.country != 'USA' && (
            <>
              <WhiteResultCard>
                <Number>{countryInfo.active} </Number>
                <Label>Total Active Cases in {countryInfo.country}</Label>
              </WhiteResultCard>

              <WhiteResultCard>
                <Number>{countryInfo.cases} </Number>
                <Label>Total Recorded Cases in {countryInfo.country}</Label>
              </WhiteResultCard>
            </>
          )}
        </MiniCardContainer>

        {graphInfo && (
          <MiniCardContainer>
            <WhiteResultCard>
              <GraphComponent
                mode={true}
                data1={graphInfo}
                data2={graphInfoDeaths}></GraphComponent>
              <AssessmentText>
                Cumulative Cases in last 60 days in {countryInfo.country}{' '}
              </AssessmentText>
            </WhiteResultCard>
          </MiniCardContainer>
        )}
 

        {vaccineInfo && (
          <MiniCardContainer>
            <WhiteResultCard>
              <GraphComponent mode={false} data1={vaccineInfo}></GraphComponent>
              <AssessmentText>
                Cumulative Vaccinations in last 60 days in {countryInfo.country}{' '}
              </AssessmentText>
            </WhiteResultCard>
          </MiniCardContainer>
        )}
      </ScrollView>
    </CardContainer>
  );
};
